module.exports = __webpack_public_path__ + "assets/c2834d7a592d02c358cfea20ed98da18.png";